<div cass="wetter_content_container">
  <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
    <mat-tab *ngFor="let land of bundeslandFilterService.getSelectedBundesLaenderNamen()" [label]="land">
      <h3 style="text-align:  left; margin-left: 20px">UV-Index</h3>
      <ng-container *ngFor="let uv of uvIndexVorhersage">
        <app-uv-index-detail [uv]="uv" *ngIf="selectedBundesland.includes(uv.ort.bundesLand)"></app-uv-index-detail>
      </ng-container>
    </mat-tab>

  </mat-tab-group>
</div>
